<template>
  <div class="p-3 mt-2 bg-white d-flex" v-if="post">
    <div class="d-block" v-if="post.post_content && post.post_content.length">
      <div v-if="post.getStep(0).title">
        <strong>
          {{ post.getStep(0).title }} ({{ post.type }})
        </strong>
      </div>
      <div v-if="post.getStep(0).subtitle">
        <span class="text-small text-primary">{{ post.getStep(0).subtitle }}</span>
      </div>
       <div>
        <span class="text-small text-muted">{{ post.created_at | date }}</span>
      </div>
    </div>

    <div class="ml-auto controls d-flex align-items-center">
      <ci-item-actions :actions="getItemActions" @click="onActionClick"/>
    </div>
  </div>
</template>

<script>
// components
import ItemActions from '@/components/ItemActions.vue';

// libs
import moment from 'moment';

export default {
  name: 'PostItem',

  components: {
    'ci-item-actions': ItemActions,
  },

  props: {
    post: {
      Type: Object,
      required: true,
    },
  },

  computed: {
    getItemActions() {
      return [
        {
          icon: 'pen',
          type: 'edit',
        },
        {
          icon: 'trash',
          type: 'delete',
        },
      ];
    },
  },

  methods: {
    onActionClick(type) {
      switch (type) {
        case 'edit': {
          const postId = this.post.id;
          this.$router.push({ path: `/posts/edit/${postId}` });
          break;
        }

        case 'delete': {
          this.$emit('post-item:delete', this.post.id);
          break;
        }

        default: {
          break;
        }
      }
    },
  },

  filters: {
    date(value) {
      if (!value) {
        return '';
      }

      return moment(value).format('DD.MM.YYYY | HH:MM:ss');
    },
  },
};
</script>
